export const STUDENT_INQUIRIES = '/student_inquiries/' as const
export const ST_INQUIRIES_PROOF_OF_STUDY = `${STUDENT_INQUIRIES}proof-of-study` as const
